import React, { useState } from "react";
import { ReactComponent as Edit } from "assets/img/icons/Edit.svg";
import { useFormik } from "formik";
import TeamService from "services/TeamService";
import classNames from "classnames";
import Loader from "components/Loader";
import CustomInput from "components/CustomInput/CustomInput";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import { ReactComponent as TickIcon } from "assets/img/icons/tick.svg";
import { useToasts } from "react-toast-notifications";
import * as Yup from "yup";
import { useTeamContext } from "store/contexts/teamContext";
import { useGlobalContext } from "store/contexts/globalContext";

var styles = {
  root: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
  },
};

export default ({ team, setTeam }) => {
  const classes = styles;
  const { updateTeam } = useGlobalContext();
  const { singleTeam } = useTeamContext();
  const [editable, setEditable] = useState(false);
  const [loader, setLoader] = useState(false);
  const { addToast } = useToasts();
  const [errorMessage, setErrorMessage] = useState("");

  const formik = useFormik({
    initialValues: {
      team_name: team?.profile?.name ?? "",
    },

    validationSchema: teamNameValidationSchema(),
    onSubmit: async (values) => {
      setLoader(true);

      var media = null;

      try {
        await TeamService.postTeamProfile(
          team.id,
          media,
          values.team_name,
          null
        );

        addToast("Team name updated successfully. ", { appearance: "success" });

        setTeam({
          ...team,
          profile: {
            ...team.profile,
            name: values.team_name,
          },
        });

        var teamCopy = { ...singleTeam };
        teamCopy.name = values.team_name;
        updateTeam(teamCopy);
      } catch (error) {
        console.log(error);
        if (error.response.status === 409) {
          setErrorState(error.response.data.message);
        }
      }

      setEditable(false);
      setLoader(false);
    },
  });

  const setErrorState = (message) => {
    setErrorMessage(message);
    setTimeout((_) => {
      setErrorMessage("");
    }, 4000);
  };

  return (
    <div>
      <div style={classes.root}>
        <div style={{ position: "absolute", top: "15px" }}>
          {loader && <Loader width={30} height={30} />}
        </div>
        {!editable && (
          <span
            className={classNames({
              teamProfileName: true,
              post_uname: true,
            })}
          >
            {team.profile.name}
          </span>
        )}
        {editable && (
          <CustomInput
            disabled={loader}
            formGroup={false}
            inputClass={"teamProfileInput"}
            errorStyle={{
              fontSize: "11px",
              position: "absolute",
              width: "100%",
              top: 0,
            }}
            inputProps={{
              type: "text",
              ...formik.getFieldProps("team_name"),
              error:
                !!formik.errors.team_name && !!formik.touched.team_name
                  ? formik.errors.team_name
                  : null,
            }}
          />
        )}
        {!editable && [2].includes(team?.role_id) && (
          <Edit
            style={{ width: "25px", cursor: "pointer" }}
            onClick={() => setEditable(!editable)}
          />
        )}
        {editable && (
          <>
            <TickIcon
              className={classNames({
                disableTeamNameAction: loader && true,
              })}
              style={{ width: "20px", cursor: "pointer", fill: "#575f6b" }}
              onClick={formik.handleSubmit}
            />
            <CancelIcon
              className={classNames({
                disableTeamNameAction: loader && true,
              })}
              style={{ width: "20px", cursor: "pointer" }}
              onClick={() => {
                formik.setFieldValue("team_name", team?.profile?.name ?? "");
                setEditable(false);
              }}
            />
          </>
        )}
      </div>
      {errorMessage && (
        <small style={{ display: "flex" }} className="errorMessage">
          {errorMessage}
        </small>
      )}
      <small className="post_time">{team?.members?.length} members</small>
    </div>
  );
};

const teamNameValidationSchema = () => {
  return Yup.object().shape({
    team_name: Yup.string()
      .min(4, "Characters must be between 4 to 50.")
      .max(50, "Characters must be between 4 to 50.")
      .required("Team Name is required"),
  });
};
